import { accountApi } from "../config/apiConfig";

export const getMinAppVersion = async () => {
  const response = await accountApi.get("/mobile-app-version");
  const data = response.data;
  return { min_version: data?.minimum_required ?? null };
};

export const setMinAppVersion = async (version) => {
  const versionPattern = /^\d{4}\.\d{2}\.\d+$/;
  if (!versionPattern.test(version)) {
    throw new Error(`Invalid version format: ${version}. Expected YYYY.WW.PP`);
  }
  const response = await accountApi.post("/mobile-app-version", {
    minimum_required: version,
  });
  return { min_version: version, message: response.data?.message };
};
